/// <amd-module name="Wit/Search/Constants" />
export const WorkItemRoute = "ms.vss-work-web.work-items-form-route-with-id";
export const InfiniteScrollTakeValue = 25;
export const HubName = "Boards";

export namespace CustomerIntelligenceConstants {
    export const Feature = "WorkItemSearchSuggestions";
    export const TTISearchScenarioName = "WorkItemSearchTTIScenario";
    export const SubsequentSearchScenarioName = "WorkItemSearchTTIScenario";
}

export namespace WitRef {
    export const title = "system.title";
    export const id = "system.id";
    export const type = "system.workitemtype";
}

export namespace FeatureFlags {
    export const DisableAggregations: string = "WebAccess.Search.WorkItem.DisableAggregations";
    export const InfiniteScroll: string = "WebAccess.Search.WorkItem.InfiniteScroll";
}